module.exports = __webpack_public_path__ + "3bac4cccf76ec3fb40f7c4e87d9137a5.svg";